import React, { useEffect, useState } from 'react';
import { UserAvatar, ProgressLoader, Spinner, Message } from "components/shared";
import { FlapHeader } from "components/layout";
import { TaskService } from "services/http/";
import utils from 'utils';

export function TaskMessages(props) {

    const [chats, setChats] = useState([]);
    const [task, setTask] = useState(props.task);
    let customer = task?.client;
    customer['username'] = `${customer.firstname} ${customer.lastname}`;
    const [loader, setLoader] = useState(false);
    const [paginateMessages, setPaginateMessages] = useState(false);
    const [messagesPageIndex, setMessagesPageIndex] = useState(0);
    const [loaderMessagesPage, setLoaderMessagesPage] = useState();

    //ON SWITCH SELECTED TASK 
    useEffect(() => {
        setLoader(true); setPaginateMessages(false);
        task && TaskService.getLazyMessages(task.interventionId, 0).then((data) => {
            setLoader(false);
            setChats(data.result.messages.reverse());
            setPaginateMessages(true ? (data.result.totalPages > 1) : false);
            //SCROLLING TO THE END
            utils.scrollChatContainerToBottom();
        }, error => {
            alert(error);
        });

        setMessagesPageIndex(0);
    }, [task.interventionId]);

    //LAZY FETCH ON SCROLL EVENT
    useEffect(() => {
        if (messagesPageIndex !== 0) {
            setLoaderMessagesPage(true);
            task && TaskService.getLazyMessages(task.interventionId, messagesPageIndex).then((data) => {
                setLoaderMessagesPage(false);
                populatingMessages(data, chats).then((result) => {
                    setChats(result);
                });
                data.result.totalPages === data.result.pageIndex && setPaginateMessages(false);
            }, error => {
                setLoaderMessagesPage(false);
                alert(error);
            });
        }
    }, [messagesPageIndex]);

    //POPULATE FETCHED MESSAGES ON CHAT STATE
    const populatingMessages = (data, chats) => new Promise((resolve) => {
        const temp = data.result.messages.reverse().concat(chats);
        resolve(temp);
    });

    useEffect(() => {
        setTask(props.task);
    }, [props.task]);


    return (
        <div className="root-conversation">
            <FlapHeader
                leftSide={
                    <div className="my-1 d-flex"> <UserAvatar image={customer.profilePic} size="small" shape="circle" /> <span className="my-1">&nbsp; Conversation - {customer.username}</span></div>
                }
                rightSide={
                    <i className={task.source.sourceId === "messenger" && "bi bi-facebook"} style={{ fontSize: "25px" }} />
                } />

            <div className="conversation-container conversation-scroll">
                {
                    paginateMessages &&
                    <div className="text-center p-2">
                        {!loaderMessagesPage ?
                            <button type="button" className="btn btn-secondary" onClick={() => { setMessagesPageIndex(pageIndex => pageIndex + 1) }} ><i className="bi bi-arrow-clockwise" /> See more</button> :
                            <Spinner />}
                    </div>
                }
                {
                    !loader ?
                        <>
                            {
                                chats.map((chat) =>
                                    <Message
                                        msgId={chat.messageId}
                                        mine={chat.direction === "outgoing" ? true : false}
                                        author={chat.direction === "outgoing" ? "Agent" : customer.username}
                                        message={chat.content}
                                        avatarImage={chat.direction === "incoming" ? customer.profilePic : null}
                                        avatarLabel={chat.direction === "outgoing" ? chat.username?.substring(0, 2).toUpperCase() : null}
                                        avatarIcon={(chat.direction === "outgoing" && chat.username === null) ? utils.guessSourceIcon(task.source.sourceId) : null}
                                        time={new Date(chat.sendDate).toLocaleString()}
                                        withAttachment={chat.withAttachment === 1}
                                        attachments={chat.attachments}
                                        reaction={chat.reaction ? chat.emoji : null}
                                        errorChat={{ error: chat.error, description: chat.descriptionError }}
                                    />
                                )
                            }
                            {
                                props.task.lastSeen && <div id="lastSeenElement" className="w-100 text-center"><small className="px-3 inline-center"><i className="bi bi-check2-all" /> Last seen : {new Date(props.task.lastSeen).toLocaleString()}</small></div>
                            }
                        </> : <ProgressLoader />
                }
            </div>

        </div>
    );
}

